import { IsBoolean, IsOptional, Length, Max, Min, MinLength } from 'class-validator';

import { AuctionStatusEnum, AuctionTypeEnum } from '@onArte/shared/enums/common';

export class AuctionsSearchCriteriaOnManagementModel {
  @IsOptional()
  @Length(6, 32)
  public type?: AuctionTypeEnum;

  @IsOptional()
  @Length(6, 32)
  public status?: AuctionStatusEnum;

  @IsOptional()
  @IsBoolean()
  public highlighted?: boolean;

  @IsOptional()
  @IsBoolean()
  public sortByHighlighted?: boolean;

  @Min(1)
  @Max(100)
  public limit: number;

  @Min(0)
  @Max(100000)
  public offset: number;

  @MinLength(1)
  @IsOptional()
  public searchQuery?: string;

  constructor(
    type?: AuctionTypeEnum,
    status?: AuctionStatusEnum,
    highlighted?: boolean,
    sortByHighlighted?: boolean,
    searchQuery?: string,
    limit: number = 100,
    offset: number = 0
  ) {
    this.type = type;
    this.status = status;
    this.highlighted = highlighted;
    this.sortByHighlighted = sortByHighlighted;
    this.limit = limit;
    this.offset = offset;
    this.searchQuery = searchQuery;
  }
}
